import { Box, Button, Heading, IconButton, Modal, Text } from '@zillow/constellation-10';
import { IconPlusFilled } from '@zillow/constellation-icons';

const CONTENT = {
  TITLE: 'Add a new rental',
  BODY: 'Create a new rental dashboard to manage your lease or rent payments.',
  ADD_BUTTON: 'Add',
} as const;

type AddRentalModalProps = {
  onAddRental: () => void;
};

const AddRentalModal = ({ onAddRental }: AddRentalModalProps) => {
  const renderBody = () => {
    return (
      <Box
        css={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          gap: 'default',
        }}
        data-testid="AddRentalModal-Body"
      >
        <Heading data-testid="AddRentalModal-Header" level={2} textStyle="heading-sm">
          {CONTENT.TITLE}
        </Heading>
        <Text>{CONTENT.BODY}</Text>
      </Box>
    );
  };

  return (
    <Modal
      trigger={
        <IconButton
          data-testid="Header-AddRental"
          title="Add rental"
          tone="brand"
          size="sm"
          aria-label="Add a new rental property"
        >
          <IconPlusFilled />
        </IconButton>
      }
      size="md"
      scrollDocument
      body={renderBody()}
      footer={
        <Modal.Close>
          <Button
            data-testid="AddRentalModal-FooterButton"
            emphasis="filled"
            size="md"
            onClick={onAddRental}
            aria-label="Add new rental property"
          >
            {CONTENT.ADD_BUTTON}
          </Button>
        </Modal.Close>
      }
    />
  );
};

export default AddRentalModal;
